import { compose } from 'lodash/fp';
import api from '../../../../api';
import PageHeader from '../../../components/PageHeader';
import PageTitle from '../../../components/PageTitle';
import { withAppContext } from '../../../hoc/withAppContext';
import { withPageData } from '../../../hoc/withPageData';
import { isFeatureEnabled } from '../../../services/Features';
import AdminOverview from './presenter';
import { countAdminErrors, groupLinksByCategory } from './service';

function AdminOverviewPage({ adminLinks, promotionLinks, appContext }) {
    const title = 'Settings';
    return (
        <div className="newLayout-contentWidthXS">
            <PageTitle title={title} />
            <PageHeader title={title} />
            <AdminOverview
                categories={groupLinksByCategory([...adminLinks, ...promotionLinks])}
                errorCount={countAdminErrors(adminLinks)}
                currentUser={appContext.user}
            />
        </div>
    );
}

export default compose(
    withPageData({
        resolve: {
            adminLinks: () => api.admin.getSettingsLinks(isFeatureEnabled('FEATURE_adminNavigationRefresh')),
            promotionLinks: () => api.admin.getPromotionsLinks(),
        },
    }),
    withAppContext
)(AdminOverviewPage);
